// components/Admin/Login.js
import React, { useState } from "react";
import AdminPanel from "./AdminPanel";

const Login = () => {
  const [password, setPassword] = useState("");
  const [authenticated, setAuthenticated] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === "8f4h7xgrG") {
      setAuthenticated(true);
    } else {
      alert("Неверный пароль");
    }
  };

  if (authenticated) return <AdminPanel />;

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "300px",
        margin: "100px auto",
        gap: "10px",
      }}
    >
      <h2>Админ-панель</h2>
      <input
        type="password"
        placeholder="Введите пароль"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ padding: "8px", fontSize: "16px" }}
      />
      <button
        type="submit"
        style={{
          padding: "8px",
          fontSize: "16px",
          background: "#007BFF",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Войти
      </button>
    </form>
  );
};

export default Login;
